import moment from 'moment';

export class PersonAdReport {
  constructor(data) {
    var self = this;
    self.type = "PersonAdReport";

    self.display_name = data.display_name;
    self.email_address = data.email_address;

    self.person_uuid = data.person_uuid;

    self.event_invites = data.event_invites;
    self.event_types = data.event_types;
    self.confirm_fee = data.confirm_fee;
    self.average_fee = data.average_fee;

    self.ad_query = data.ad_query;
    self.event_states = data.event_states;
    self.event_types = data.event_types_array;
    self.event_json = data.event_json;
    self.landing_page = data.landing_page;
    self.short_landing = data.short_landing;

    self.campaign_id = data.campaign_id;

    var campaignNames = {
      '20090474296': 'DE  | Musiker buchen - RW',
      '21250922572': 'Leads-Performance Max - RW',
      '20064782126': 'DE | Band buchen + Geokeyword- RW',
      '20064784004': 'Stuttgart  | Band buchen - OLD',
      '20068923046': 'Leipzig  | Band buchen - OLD',
      '20086316810': 'DE  | Hochzeitsband - neu',
      '20064783545': 'DE  | Hochzeit + Geokeyword - neu',
      '21904477618': 'DE  | SEA - Update - NEW',
      '20993025028': 'DE  | Geburtstagsband - neu',
      '22938493421': '_',
      '22862613003': 'Weihnachtsfeier 2025',
    };

    self.campaign_pretty = ko.pureComputed(function () {
      return campaignNames[self.campaign_id] || self.campaign_id;
    });

    self.nos_received = ko.pureComputed(function () {
      if (!self.event_states) return 0;
      return self.event_states.filter(s => s && s.startsWith('no-')).length;
    });

    self.inserted = new moment(data.inserted_date);

    self.referrer = data.referrer;
    self.referrer_group = data.referrer_group;

    self.extra_notes = ko.observable(data.admin_comment);

    self.editing_extra_notes = ko.observable(false);
    self.new_extra_notes = ko.observable(data.extra_notes);

    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.save_extra_notes = function () {
      self.editing_extra_notes(false);

      return $.ajax({
        url: scvm.web_host + "/api/admin/people/admin-comment",
        type: "POST",
        data: ko.toJSON({
          person_uuid: self.person_uuid,
          admin_comment: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.admin_comment);
            self.new_extra_notes(data.admin_comment);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
            self.editing_extra_notes(true);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };
  }
}
